import {
  googleMapsEmbedUrl,
  siteConfig,
} from "../../content/site";

export function CompanyMap() {
  return (
    <section
      id="company"
      className="company section section--standard section--dark"
      data-review-region="company-information"
      data-auth-signature="matsushima-entity-proof"
      aria-labelledby="company-title"
    >
      <div className="section-shell">
        <div className="section-intro">
          <p className="section-kicker">運営者情報と所在地</p>
          <h2 id="company-title">事業者情報・所在地</h2>
        </div>
        <div className="company__layout">
          <div className="company__details">
            <dl>
              <div>
                <dt>屋号</dt>
                <dd>{siteConfig.businessName}</dd>
              </div>
              <div>
                <dt>代表者</dt>
                <dd>{siteConfig.representative}</dd>
              </div>
              <div>
                <dt>所在地</dt>
                <dd>{siteConfig.address}</dd>
              </div>
              <div>
                <dt>電話番号</dt>
                <dd>
                  <a href={siteConfig.phoneHref}>{siteConfig.phoneDisplay}</a>
                </dd>
              </div>
              <div>
                <dt>受付</dt>
                <dd>
                  {siteConfig.contactNote}
                  <br />
                  {siteConfig.closedDay}
                </dd>
              </div>
              <div>
                <dt>開業</dt>
                <dd>{siteConfig.establishedYear}</dd>
              </div>
            </dl>
          </div>
          <div className="company__map">
            <div className="company__map-frame">
              <iframe
                src={googleMapsEmbedUrl}
                title={`松島オート店舗所在地（${siteConfig.addressWithoutPostalCode}）のGoogleマップ`}
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                allowFullScreen
                data-testid="google-map-embed"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
